import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import FormDatosFacturacion from "../../components/datosFacturacion/datosFacturacion";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {listarECivilesFetch, listarGenerosFetch, listarProvinciasFetch, listarCiudadesFetch, fetchConsultarIdentificacionAP,recuperarDatosFacturacionFetch } from "../../redux/actions/aCotizacion";
import LoadingScreen from "react-loading-screen";
import {FetchTotalesCabeceraCotizadores} from "../../redux/actions/ACarritoProductos";

class ContainerDatosFacturacion extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      cargando:true
    }
    this.onChangeProvincia=this.onChangeProvincia.bind(this);
    
  }
  
  async componentDidMount() {
    //const idCliente = this.props.datosCarrito.productosCarrito.cliCodigoCore
    //await this.props.getDatosCliente(idCliente);
    await this.props.listarEstadosCiviles();
    await this.props.listarGeneros();
    await this.props.listarProvincias();

    const queryParams = new URLSearchParams(this.props.location.search);
    let datosJSON ='';
    if(queryParams.get('id') !== null){
        /*Consulta Carrito*/  
        datosJSON = {
          empresa:"AIGMETROPOLITANA",
          plataforma:"WEB",
          idCarrito: queryParams.get('id')
        }
    }
    await this.props.datosFacturacion(datosJSON);  
    //Cargar Totales de la cabecera
    if(this.props.dataFacturacion2 !== undefined && this.props.dataFacturacion2 !== "")
    {              
      let param={
        pathIcono:this.props.dataFacturacion2.pathIconoTotalesCabecera?this.props.dataFacturacion2.pathIconoTotalesCabecera:"", 
        totalItems:this.props.dataFacturacion2.numItemsCarrito?this.props.dataFacturacion2.numItemsCarrito:"0", 
        totalPrima:(this.props.dataFacturacion2.carValoresTotales && this.props.dataFacturacion2.carValoresTotales.primaTotal)?this.props.dataFacturacion2.carValoresTotales.primaTotal:"0.00", 
        ramoCotizador:this.props.dataFacturacion2.carDescripcionRamo?this.props.dataFacturacion2.carDescripcionRamo:"", 
      }
      await this.props.actualizarTotalesCabecera(param);
    }

    this.setState({
      cargando:false
    })    

    const{dataFacturacion}=this.props;

    if(dataFacturacion.datosFacturacion && dataFacturacion.datosFacturacion.datosPagador){
      this.props.history.push({
        pathname: "/forma-pago",
        search: `?id=${queryParams.get('id')}`,
      });
    }


  }

  async onChangeProvincia(param){
    await this.props.listarCiudades(param);
  }

  async consultarIdentificacion(params){
    await this.props.consultarIdentificacion(params)
  }

  textosCargando(){
    if(this.props.dataFacturacion.recuperarDatosFacturacionIsLoading)
      return "Cargando información para facturación..."
    if(this.state.cargando)
      return "Cargando información para el pago..."
    if(this.props.catalogos.listarCiudadesIsLoading)
      return "Cargando catálogo de ciudades..."
    if (this.props.datosIdentificacion.consultarIdentificacionAPIsLoading)
      return "Cargando datos del cliente..."
  }

  render() {

    const{cargando}=this.state;
    const{catalogos,datosIdentificacion,dataFacturacion}=this.props;
    return (
      <LoadingScreen
        loading={cargando || catalogos.listarCiudadesIsLoading || datosIdentificacion.consultarIdentificacionAPIsLoading || dataFacturacion.recuperarDatosFacturacionIsLoading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text={this.textosCargando()}
      >
      <main className="cr-app bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces"> 
            {!cargando  &&
              <FormDatosFacturacion onChangeProvincia={  this.onChangeProvincia} consultarIdentificacion={this.consultarIdentificacion} dataFacturacion={dataFacturacion.datosFacturacion}/>
            }
            </div>
        </div>
      </main>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = state => ({
  datosIdentificacion : state.datosIdentificacionAP,
  catalogos:state.catalogosCotizacion,
  dataFacturacion : state.dataFacturacion,
  dataFacturacion2 : state.dataFacturacion.datosFacturacion
});

const mapDispatchToProps = dispatch => {
  return {
    //getDatosCliente: idCliente => dispatch(obtenerDatosClienteFetch(idCliente)),
    listarEstadosCiviles: () => dispatch(listarECivilesFetch()),
    listarGeneros: () => dispatch(listarGenerosFetch()),
    listarProvincias: () => dispatch(listarProvinciasFetch()),
    listarCiudades: (provincia) => dispatch(listarCiudadesFetch(provincia)),
    consultarIdentificacion: datos => dispatch(fetchConsultarIdentificacionAP(datos)),
    datosFacturacion: (data) => dispatch(recuperarDatosFacturacionFetch(data)),
    actualizarTotalesCabecera:(param) => dispatch(FetchTotalesCabeceraCotizadores(param)), 
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerDatosFacturacion)
);
